<template>
  <footer
    class="axion-footer text-center py-3 mt-auto"
    :class="{ 'footer-shift': sidebarOpen }"
  >
    © {{ new Date().getFullYear() }} Axion Academy
  </footer>
</template>

<script>
export default {
  name: "FooterView",
  props: {
    sidebarOpen: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.axion-footer {
  background: linear-gradient(90deg, #1a001f, #2b0033);
  border-top: 1px solid #ff00cc;
  color: #ff99ff;
  font-weight: 500;
  text-shadow: 0 0 5px #ff00cc, 0 0 10px #ff00cc;
  transition: margin-left 0.3s ease, background 0.3s ease;
  padding: 15px 0;
  z-index: 1050;
}

.footer-shift {
  margin-left: 250px; /* match sidebar width */
}
</style>
